import React, { FC } from 'react'
import { useHeaderHeight } from 'hooks/useHeaderHeight'

export type LayoutProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  children: React.ReactNode
}

const Layout: FC<LayoutProps> = props => {
  useHeaderHeight()
  // eslint-disable-next-line react/prop-types
  const { className, ...restProps } = props
  const classes = className ? `slnw-layout ${className}` : 'slnw-layout'
  return <div {...restProps} className={classes} />
}

export default Layout
